import SelecaoEntidade from '@/modules/entidade/SelecaoEntidade.vue';
import store from '@/store';
import { INITIALIZE_FROM_COOKIES_AC } from '@/store/auth/actions.type';

const beforeEnterAuth = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    if (store.getters.tokenFromStorage) {
      store.dispatch(INITIALIZE_FROM_COOKIES_AC);
      return next();
    }
    return next('/login');
  }
  return next();
};

export default {
  path: '/selecao-entidade',
  name: 'selecao-entidade',
  component: SelecaoEntidade,
  beforeEnter: beforeEnterAuth,
};
